// extracted by mini-css-extract-plugin
export default {"withdraw_container":"Withdraw_withdraw_container__CuO4k","header":"Withdraw_header__HL3v9","payment":"Withdraw_payment__-vLeu"};